import React, { FC, useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { getUnreadNotificationCount } from '../../../../app/modules/notifications/api';
import { NOTIFICATIONS_UPDATED_EVENT } from '../../../../app/modules/notifications/event';

const NotificationsButton: FC = () => {
    const history = useHistory()
    const [unreadCount, setUnreadCount] = useState(0);

    const loadUnreadCount = useCallback(async () => {
        try {
            setUnreadCount(await getUnreadNotificationCount())
        }
        catch {
            setUnreadCount(0)
        }
    }, [])

    useEffect(() => {
        void loadUnreadCount()
        const interval = window.setInterval(() => void loadUnreadCount(), 60000)
        const handleUpdated = () => void loadUnreadCount()
        window.addEventListener(NOTIFICATIONS_UPDATED_EVENT, handleUpdated)
        return () => {
            window.clearInterval(interval)
            window.removeEventListener(NOTIFICATIONS_UPDATED_EVENT, handleUpdated)
        }
    }, [loadUnreadCount])

    return (
        <button
            type='button'
            className='btn btn-icon btn-active-light-primary position-relative w-30px h-30px w-md-40px h-md-40px'
            title='Notifications'
            aria-label={`Notifications${unreadCount ? `, ${unreadCount} unread` : ''}`}
            onClick={() => history.push('/notifications')}
        >
            <i className='bi bi-bell fs-2' aria-hidden='true'></i>
            {unreadCount > 0 && (
                <span className='position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger fs-8'>
                    {unreadCount > 99 ? '99+' : unreadCount}
                </span>
            )}
        </button>
    )
}

export default NotificationsButton